export const getAccurateTimeToRead = (timeToRead) => timeToRead + 1;
